<div class="h-screen bg-gray-50 grid grid-rows-[auto_1fr] overflow-hidden">
  <!-- Banner Component -->
  <app-auth-banner />

  <div class="h-full w-full flex items-center justify-center">
    <div class="w-full max-w-md space-y-8">
      <!-- Loading Skeleton -->
      @if (!isComponentReady()) {
      <sb-loading-skeleton type="login" />
      } @else {
      <!-- Actual Content with Animation -->
      <div class="animate-slideInUp">
        <div class="flex flex-col gap-y-4">
          <app-login-header />

          <div class="flex flex-col justify-center items-center gap-y-1">
            <h2 class="text-center text-3xl font-extrabold text-gray-700">
              Sign in
            </h2>
          </div>
        </div>

        @if (companyOptions().length === 0) {
        <form class="space-y-6 mt-8" (ngSubmit)="onSubmit()" #form="ngForm">
          <!-- Error Alert -->
          <lib-error-alert [error]="authStore.error()" />

          <div class="flex flex-col gap-y-4">
            <!-- Email/Username Field -->
            <div class="animate-slideInLeft" style="animation-delay: 100ms">
              <sb-text-input
                id="identifier"
                name="identifier"
                label="Email or Username"
                type="text"
                autocomplete="username"
                [required]="true"
                [(ngModel)]="formData().identifier"
                (inputBlur)="validateField('identifier')"
                [errorMessage]="formErrors()['identifier']"
                placeholder="Email or username"
              />
            </div>

            <!-- Password Field -->
            <div
              class="flex flex-col gap-y-1 animate-slideInLeft"
              style="animation-delay: 200ms"
            >
              <sb-text-input
                id="password"
                name="password"
                label="Password"
                type="password"
                autocomplete="current-password"
                [required]="true"
                [(ngModel)]="formData().password"
                (inputBlur)="validateField('password')"
                (keydown.enter)="$event.preventDefault(); onSubmit()"
                [errorMessage]="formErrors()['password']"
                placeholder="Password"
              />

              <div class="flex items-center justify-end w-full text-sm">
                <a
                  routerLink="/forgot-password"
                  class="font-medium text-orange-400 hover:text-orange-300 transition-colors duration-200"
                >
                  Forgot your password?
                </a>
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-4">
            <div class="animate-slideInUp" style="animation-delay: 300ms">
              <app-submit-login-button
                text="Sign in"
                loadingText="Signing in..."
                [isLoading]="authStore.isLoading()"
                [disabled]="!isFormValid()"
                (submitClick)="onSubmit()"
              />
            </div>

            <!-- Social Sign In Divider -->
            <div
              class="relative animate-slideInUp"
              style="animation-delay: 400ms"
            >
              <div class="absolute inset-0 flex items-center">
                <div class="w-full border-t border-gray-200"></div>
              </div>
              <div class="relative flex justify-center text-sm">
                <span class="px-2 text-gray-500">Or sign in with</span>
              </div>
            </div>

            <div class="animate-slideInUp" style="animation-delay: 500ms">
              <app-google-login-button (googleClick)="onGoogleSignIn()" />
            </div>

            <div
              class="text-sm text-center text-gray-500 animate-slideInUp"
              style="animation-delay: 600ms"
            >
              Don't have an account?
              <a
                routerLink="/register"
                class="font-medium text-orange-400 hover:text-orange-300 transition-colors duration-200"
              >
                Sign up
              </a>
            </div>
          </div>
        </form>
        } @else {
        <div class="space-y-6 mt-8">
          <lib-error-alert [error]="authStore.error()" />

          <div class="text-center space-y-2">
            <h3 class="text-xl font-semibold text-gray-800">
              Choose a company to continue
            </h3>
            <p class="text-sm text-gray-500">
              Your account has access to
              {{ companyOptions().length }} companies.
            </p>
          </div>

          <div class="flex flex-col gap-3">
            @for (company of companyOptions(); track company.id) {
            <button
              type="button"
              (click)="onCompanySelected(company)"
              class="flex flex-col items-start gap-y-1 rounded-lg border border-gray-200 bg-white px-4 py-3 text-left shadow-sm transition hover:border-orange-300 hover:shadow"
            >
              <span class="text-base font-semibold text-gray-900">
                {{ company.name }}
              </span>
              <span class="text-sm text-gray-500"
                >Code: {{ company.code }}</span
              >
            </button>
            }
          </div>

          <button
            type="button"
            (click)="clearCompanySelection()"
            class="w-full rounded-md border border-transparent bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300 transition"
          >
            Use different credentials
          </button>
        </div>
        }
      </div>
      }
    </div>
  </div>
</div>
